
import { defineComponent } from "vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    IntegerControl,
  },
  props: {
    model: { required: true },
  },
  created(){
    this.modelLocal = this.model;
  },
  methods: {},
  data(){
    return {
      modelLocal: null,
      weight: [{name: "cabinAxle", top: 310, left: 50},
        {name: "tractorFirstAxle", top: 310, left: 240}, 
        {name: "tractorSecondAxle", top: 310, left: 330}, 
        {name: "semitrailerFirstAxle", top: 310, left: 535},
        {name: "semitrailerSecondAxle", top: 310, left: 605},
        {name: "semitrailerThirdAxle", top: 310, left: 675},
        {name: "semitrailerFourthAxle", top: 310, left: 745}],
      distance: [{name: "tractorAxlesDistanceFirst", top: 134, left: 163, width: 35},
        {name: "tractorAxlesDistanceSecond", top: 134, left: 208, width: 56},
        {name: "tractorAxlesDistanceThird", top: 134, left: 289, width: 56},
        {name: "semitrailerAxlesDistanceFirst", top: 134, left: 645, width: 50},
        {name: "semitrailerAxlesDistanceSecond", top: 134, left: 707, width: 50},
        {name: "tractorCabinAxlesDistance", top: 260, left: 148, width: 56},
        {name: "tractorSemitrailerAxlesDistance", top: 98, left: 396, width: 56}],
    };
  },
});
